import React, {useRef, useState} from "react";
import {
    Box,
    Button, ButtonGroup,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Divider,
    TextField, Typography, useTheme
} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const passColour = "#090", failColour = "#c00"

const useStyles = makeStyles(theme => {
    return {
        tests: {
            margin: theme.spacing(2, 0),
            "& > div": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: theme.spacing(1),
                "& > div": {
                    marginLeft: theme.spacing(1),
                    "& > button:first-child.MuiButton-contained": {
                        backgroundColor: passColour,
                        color: "#fff"
                    },
                    "& > button:last-child.MuiButton-contained": {
                        backgroundColor: failColour,
                        color: "#fff"
                    }
                }
            }
        },
        ticketId: {
            marginBottom: theme.spacing(2)
        }
    }
})

const VARIANTS = {
    manufacture: [
        'Commissioning successfully completed',
        'Manufacture test passed'
    ],
    install: [
        'Installations checklist completed',
        'Walk up test passed',
        'Data connection working and events correctly displayed',
        'Status Result field set to 0'
    ],
    repair: [
        'Repair successfully completed',
        'Walk up test passed',
        'Data connection working and events correctly displayed',
        'Status Result field set to 0'
    ]
}

function PassFailButtons({label, onChange, checked}){
    return <Typography variant="body2" component="div">
        {label}
        <ButtonGroup>
            <Button
                onClick={() => onChange(true)}
                variant={checked === true ? "contained" : "outlined"}
            >Pass</Button>
            <Button
                onClick={() => onChange(false)}
                variant={checked === false ? "contained" : "outlined"}
            >Fail</Button>
        </ButtonGroup>
    </Typography>
}

export default function CheckListDialog({open, variant, onDone, onCancel, collectTicketId}){
    const style = useStyles(useTheme()), items = VARIANTS[variant]
    const [update, setUpdate] = useState(false)
    const [notes, setNotes] = useState('')
    const [ticketId, setTicketId] = useState('')
    const valuesRef = useRef(Array(items.length))

    const values = valuesRef.current

    function passed(){
        for (let i = 0, j = values.length; i < j; ++i){
            if (!values[i]){
                return false;
            }
        }
        return true;
    }

    function save(){
        const out = {
            test_type:  variant,
            passed: passed(),
            checklist: items.map((item, idx) => {
                return {
                    title: item,
                    passed: !!values[idx]
                }
            }),
            message: notes
        }
        if (collectTicketId){
            out.ticket_id = ticketId
        }
        onDone(out)
    }

    return <Dialog open={open}>
        <DialogTitle>{`Post ${variant} checks`}</DialogTitle>
        <DialogContent>
            <Typography variant="body1">
                Please assess the following
            </Typography>
            <Divider/>
            <Box className={style.tests}>
                {
                    items.map((desc, id) => <PassFailButtons
                        key={id}
                        label={desc}
                        onChange={passed => {
                            values[id] = passed
                            setUpdate(!update)
                        }}
                        checked={values[id]}
                    />)
                }
            </Box>
            {collectTicketId ?
                <TextField
                    className={style.ticketId}
                    label={`${variant.charAt(0).toUpperCase()}${variant.substring(1)} Ticket ID`}
                    variant="outlined"
                    onChange={(e) => setTicketId(e.target.value)}
                    value={ticketId}
                    helperText="Required field"
                    fullWidth
                /> : null
            }
            <TextField
                label="Notes"
                variant="outlined"
                onChange={(e) => setNotes(e.target.value)}
                value={notes}
                rows={4}
                multiline
                fullWidth
            />
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
                Cancel
            </Button>
            <Button variant="contained" onClick={save} disabled={collectTicketId && !/\S+/.test(ticketId)}>
                Done
            </Button>
        </DialogActions>
    </Dialog>
}
